import { Routes } from '@angular/router'

import { AuthGuard } from '../../auth/auth-guard.service'
import { ApiKeysComponent } from '../account/components/api-keys/api-keys.component'
import { IframeGuard } from '../shared/guards/iframe.guard'

import { AppearanceComponent } from './components/appearance/appearance.component'
import { CompanySettingsComponent } from './components/company-settings/cs.component'
import { EnvironmentComponent } from './components/environment/environment.component'
import { ToolComponent } from './components/environment/tool/tool.component'
import { MyFavoritesComponent } from './components/favorites/favorites.component'
import { ManageUsersComponent } from './components/manage-users/mu.component'
import { MyAccountComponent } from './components/my/my.component'
import { SettingsComponent } from './settings.component'

export const SettingsRoutes: Routes = [
  {
    path: '',
    component: SettingsComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'profile', component: MyAccountComponent },
      { path: 'environment', component: EnvironmentComponent },
      {
        path: 'environment/:environmentId/tool',
        component: ToolComponent,
      },
      {
        path: 'environment/:environmentId/tool/:toolId',
        component: ToolComponent,
      },
      {
        path: 'appearance',
        canActivate: [IframeGuard],
        component: AppearanceComponent,
      },
      { path: 'api-keys', component: ApiKeysComponent },
      { path: 'favorites', component: MyFavoritesComponent },
      {
        path: 'company-information',
        canActivate: [IframeGuard],
        component: CompanySettingsComponent,
      },
      {
        path: 'manage-users',
        canActivate: [IframeGuard],
        component: ManageUsersComponent,
      },
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
    ],
  },
]
